var map = {
	"./hero-dark.jpg": "03b6",
	"./hero.jpg": "6ee5",
	"./phb_cover.jpg": "0ab2",
	"./sav_cover.jpg": "3bf5",
	"./sotg_cover.jpg": "4db2",
	"./wh_cover.jpg": "3065"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";